module.exports = __webpack_public_path__ + "static/media/GYM Content.b75b7344.png";